import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0E1730] py-16 px-6 md:px-12 border-t border-white/10">
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src="/assets/veristamp_icon_master.svg" alt="" width="36" height="36" loading="lazy" className="h-9 w-9 rounded-lg" />
            <span className="font-heading font-extrabold text-[#F7F6F2] tracking-wide">VERISTAMP</span>
          </div>
          <p className="mt-3 text-sm text-[#C9A227] font-semibold tracking-widest uppercase">Timestamped. Tamper-evident.</p>
          <p className="mt-4 text-xs text-[#F7F6F2]/60">No trackers. No ads.</p>
        </div>
        <div className="flex flex-wrap gap-16 text-sm">
          <div className="flex flex-col gap-3">
            <span className="text-[#F7F6F2]/60 text-xs uppercase tracking-widest">Guides</span>
            <Link to="/ab-2801" data-testid="footer-ab2801-link" className="text-[#F7F6F2]/70 hover:text-[#C9A227] transition-colors duration-300">AB 2801 photo requirements</Link>
            <Link to="/move-in-checklist" data-testid="footer-checklist-link" className="text-[#F7F6F2]/70 hover:text-[#C9A227] transition-colors duration-300">Move-in checklist</Link>
            <Link to="/security-deposit-disputes" data-testid="footer-disputes-link" className="text-[#F7F6F2]/70 hover:text-[#C9A227] transition-colors duration-300">Winning deposit disputes</Link>
            <Link to="/vs-camera-roll" data-testid="footer-cameraroll-link" className="text-[#F7F6F2]/70 hover:text-[#C9A227] transition-colors duration-300">Vs. camera roll photos</Link>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-[#F7F6F2]/60 text-xs uppercase tracking-widest">Legal</span>
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-[#F7F6F2]/70 hover:text-[#C9A227] transition-colors duration-300">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="text-[#F7F6F2]/70 hover:text-[#C9A227] transition-colors duration-300">Terms of Service</Link>
            <Link to="/delete-account" data-testid="footer-delete-account-link" className="text-[#F7F6F2]/70 hover:text-[#C9A227] transition-colors duration-300">Delete your account</Link>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-[#F7F6F2]/60 text-xs uppercase tracking-widest">Contact</span>
            <a href="mailto:verify@veristamp.app" data-testid="footer-contact-link" className="text-[#F7F6F2]/70 hover:text-[#C9A227] transition-colors duration-300">
              verify@veristamp.app
            </a>
          </div>
        </div>
      </div>
      <p data-testid="footer-disclaimer" className="mt-12 pt-8 border-t border-white/10 text-xs text-[#F7F6F2]/60 leading-relaxed">
        Veristamp is not a law firm and does not provide legal advice or notarization services.
        © {new Date().getFullYear()} Veristamp · veristamp.app
      </p>
    </div>
  </footer>
);
